import React, { forwardRef, useState } from 'react';
import PartnerCard from './partner_card';

const CardContainer = forwardRef(({ title, partnersList, classList = '' }, ref) => {

  const renderCards = () => {
    return partnersList.map((partner) => (
      <PartnerCard partner={partner} key={partner.id} />
    ));
  }
  const labelClasses = 't1 w3 pl-15 sticky-title ' + classList;
  const gridClasses = `card-grid pb-100`;

  return (
    <div ref={ref}>
      <label className={labelClasses}>{title}</label>
      <div className='gradient'></div>
      {partnersList && <div className={gridClasses}>{renderCards()}</div>}
    </div>
  );
});


export default CardContainer;
